"use strict";
/**
* Copyright: Microsoft 2016
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var localizer_1 = require("./localizer");
var React = require("react");
exports.Translate = function (props) {
    var newProps = __assign({}, props);
    delete newProps['msg'];
    return React.createElement("span", null, localizer_1.localizer.get(props.msg, newProps));
};
